import { render, staticRenderFns } from "./feedback_3_0.vue?vue&type=template&id=0b801c9c&"
import script from "./feedback_3_0.vue?vue&type=script&lang=js&"
export * from "./feedback_3_0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports